export function helloWorld(msg?: string) {
  // eslint-disable-next-line no-console
  console.log(`Hello ${msg || "world"}!`);
}
